var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type } from "@colyseus/schema";
/** Where a live cursor is, wire-wise. Board positions are expressed in the
 * shared board plane — units of one hex size, origin at the board centre — so
 * they are independent of every client's own pan/zoom/rotation/tilt camera:
 * each receiver re-projects the point through its own camera and the cursor
 * lands on the exact same spot of the same tile for everyone. */
export const CURSOR_AREAS = ["board", "market", "roster", "lobby"];
/** One connected client's live pointer, keyed by session id in
 * `GameState.cursors`. Connection-scoped presence like `Spectator` — never
 * persisted, and deleted the moment the pointer hides (window blur / idle /
 * leaves every shared surface) or the socket closes. */
export class CursorState extends Schema {
    constructor() {
        super(...arguments);
        /** Surface the pointer is on: "board" | "market" (right sidebar) |
         * "roster" (left sidebar) | "lobby" (the pre-game ready-up card). Hidden
         * cursors are deleted, not flagged. */
        this.area = "board";
        /** board: x in hex-size units from the board centre.
         *  market/roster/lobby: x normalised 0..1 across the panel. */
        this.x = 0;
        /** board: y in hex-size units from the board centre.
         *  market/roster/lobby: y normalised 0..1 down the panel. */
        this.y = 0;
        /** Sidebar/lobby element under the pointer (`card:<cardId>`,
         * `player:<sessionId>`, `history:<entryId>`, `lobby:ready`), so receivers
         * can anchor the cursor to the SAME card or row locally whatever their own
         * layout/scroll/collapse state. "" when over no keyed element (receivers
         * fall back to the normalised x/y). */
        this.target = "";
        /** Position WITHIN the `target` element, normalised 0..1 across its width
         * (`tx`) and height (`ty`) — so a receiver places the cursor on the exact
         * spot of its own copy of that card/row, not just somewhere on it. Element
         * sizes differ per client, so panel-level x/y can't express this.
         * Meaningless (0.5) when `target` is "". */
        this.tx = 0.5;
        this.ty = 0.5;
    }
}
__decorate([
    type("string")
], CursorState.prototype, "area", void 0);
__decorate([
    type("float32")
], CursorState.prototype, "x", void 0);
__decorate([
    type("float32")
], CursorState.prototype, "y", void 0);
__decorate([
    type("string")
], CursorState.prototype, "target", void 0);
__decorate([
    type("float32")
], CursorState.prototype, "tx", void 0);
__decorate([
    type("float32")
], CursorState.prototype, "ty", void 0);
//# sourceMappingURL=CursorState.js.map